/* unplugin-vue-components disabled */import script from "./XTinyMce.vue?vue&type=script&setup=true&lang=ts"
export * from "./XTinyMce.vue?vue&type=script&setup=true&lang=ts"

import "./XTinyMce.vue?vue&type=style&index=0&id=5a78e82e&lang=scss"

const __exports__ = script;

export default __exports__